// import './css/style.css';
import FbGridImages from './components/Images'

export default FbGridImages;
